<template>
  <div class="w-1360 user-layout mx-auto flex pt-18">
    <div class="w-174 bg-white">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        popper-effect="light"
        menu-trigger="click"
        :unique-opened="true"
        v-model:openeds="openSubMenuKeys"
        @select="handleOpen"
      >
        <el-menu-item index="1" @click="router.push('/user/userInfo')">
          <!-- <span class="iconfont icon-user mr-10"></span>-->
          <img
            v-if="defaultActive == 1"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-grxx.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-grxx.png"
            class="imgsize"
          />
          <span>个人信息</span>
        </el-menu-item>
        <el-menu-item index="2" @click="router.push('/user/registration')">
          <!--          <span class="iconfont icon-menu_bmlb mr-10"></span>-->
          <img
            v-if="defaultActive == 2"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-bmsq.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-bmsq.png"
            class="imgsize"
          />
          <span>报名申请</span>
        </el-menu-item>
        <el-sub-menu index="3">
          <template #title>
            <!--            <span class="iconfont icon-dingdan mr-10"></span>-->
            <img
              v-if="
                defaultActive == 3 ||
                defaultActive == '3-1' ||
                defaultActive == '3-2' ||
                defaultActive == '3-3'
              "
              src="https://res.hangxintong.cn/nxjpWx/individual/l-wddd.png"
              class="imgsize"
            />
            <img
              v-else
              src="https://res.hangxintong.cn/nxjpWx/individual/h-wddd.png"
              class="imgsize"
            />
            <span
              :style="{
                color:
                  defaultActive == '3-1' ||
                  defaultActive == '3-2' ||
                  defaultActive == '3-3'
                    ? '#0060EF'
                    : '',
              }"
              >我的订单</span
            >
          </template>
          <el-menu-item index="3-1" @click="router.push('/user/unpaid')">
            待支付订单
          </el-menu-item>
          <el-menu-item index="3-2" @click="router.push('/user/paid')">
            已支付订单
          </el-menu-item>
          <el-menu-item index="3-3" @click="router.push('/user/refund')">
            退款订单
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="4" @click="router.push('/user/myCardRoll')">
          <!--          <span class="iconfont icon-kaquan-fill mr-10"></span>-->
          <img
            v-if="defaultActive == 4"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-wdkj.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-wdkj.png"
            class="imgsize"
          />
          <span>我的卡券</span>
        </el-menu-item>
        <el-menu-item index="5" @click="router.push('/user/myInvoice')">
          <!--          <span class="iconfont icon-fapiaochangliangguanli mr-10"></span>-->
          <img
            v-if="defaultActive == 5"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-wdfp.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-wdfp.png"
            class="imgsize"
          />
          <span>我的发票</span>
        </el-menu-item>
        <el-menu-item index="6" @click="router.push('/user/myCollection')">
          <!--          <span class="iconfont icon-shoucang mr-10"></span>-->
          <img
            v-if="defaultActive == 6"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-wdsc.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-wdsc.png"
            class="imgsize"
          />
          <span>我的收藏</span>
        </el-menu-item>
        <el-sub-menu index="7">
          <template #title>
            <!--            <span class="iconfont icon-zizhizhengshu mr-10"></span>-->
            <img
              v-if="
                defaultActive == 7 ||
                defaultActive == '7-1' ||
                defaultActive == '7-2'
              "
              src="https://res.hangxintong.cn/nxjpWx/individual/l-wdzs.png"
              class="imgsize"
            />
            <img
              v-else
              src="https://res.hangxintong.cn/nxjpWx/individual/h-wdzs.png"
              class="imgsize"
            />
            <span
              :style="{
                color:
                  defaultActive == '7-1' || defaultActive == '7-2'
                    ? '#0060EF'
                    : '',
              }"
              >我的证书</span
            >
          </template>
          <el-menu-item index="7-1" @click="router.push('/user/myCert')">
            持有证书
          </el-menu-item>
          <el-menu-item index="7-2" @click="router.push('/user/myVerCard')">
            学时审验卡
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item
          index="10"
          @click="router.push('/user/InformationDisclosure')"
        >
          <!--          <span class="iconfont icon-zhengshu mr-10"></span>-->
          <img
            v-if="defaultActive == 10"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-xxdy.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-xxdy.png"
            class="imgsize"
          />
          <span>信息公示</span>
        </el-menu-item>
        <el-menu-item index="11" @click="router.push('/user/Notification')">
          <!--          <span class="iconfont icon-zhengshu mr-10"></span>-->
          <img
            v-if="defaultActive == 11"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-xxtz.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-xxtz.png"
            class="imgsize"
          />
          <span>消息通知</span>
        </el-menu-item>
        <!--        <el-menu-item index="8" @click="router.push('/user/feedback')">-->
        <!--          &lt;!&ndash;          <span class="iconfont icon-zhengshu mr-10"></span>&ndash;&gt;-->
        <!--          <img-->
        <!--            v-if="defaultActive == 8"-->
        <!--            src="https://res.hangxintong.cn/nxjpWx/individual/l-yjfk.png"-->
        <!--            class="imgsize"-->
        <!--          />-->
        <!--          <img-->
        <!--            v-else-->
        <!--            src="https://res.hangxintong.cn/nxjpWx/individual/h-yjfk.png"-->
        <!--            class="imgsize"-->
        <!--          />-->
        <!--          <span>意见反馈</span>-->
        <!--        </el-menu-item>-->
        <el-menu-item index="9" @click="router.push('/user/support')">
          <!--          <span class="iconfont icon-Fill mr-10"></span>-->
          <img
            v-if="defaultActive == 9"
            src="https://res.hangxintong.cn/nxjpWx/individual/l-jszz.png"
            class="imgsize"
          />
          <img
            v-else
            src="https://res.hangxintong.cn/nxjpWx/individual/h-jszz.png"
            class="imgsize"
          />
          <span>技术支持</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="flex-1">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
const router = useRouter()
const defaultActive = ref('1')
const openSubMenuKeys = ref([])

watch(
  () => router.currentRoute.value,
  newValue => {
    switch (newValue.path) {
      case '/user/userInfo':
        defaultActive.value = '1'
        break
      case '/user/registration/registrationInfo':
      case '/user/registration':
        defaultActive.value = '2'
        break
      case '/user/unpaid':
        defaultActive.value = '3-1'
        break
      case '/user/paid/orderInfo':
      case '/user/paid/exchange':
      case '/user/paid':
        defaultActive.value = '3-2'
        break
      case '/user/refund':
      case '/user/refund/refchange':
        defaultActive.value = '3-3'
        break
      case '/user/myCardRoll':
        defaultActive.value = '4'
        break
      case '/user/CardExchange':
        defaultActive.value = '4'
        break
      case '/user/myInvoice':
        defaultActive.value = '5'
        break
      case '/user/myCollection':
        defaultActive.value = '6'
        break
      case '/user/myCert/myCertInfo':
      case '/user/myCert':
        defaultActive.value = '7-1'
        break
      case '/user/myVerCard':
        defaultActive.value = '7-2'
        break
      case '/user/feedback':
        defaultActive.value = '8'
        break
      case '/user/support':
        defaultActive.value = '9'
        break
      case '/user/InformationDisclosure':
        defaultActive.value = '10'
        break
      case '/user/Notification':
        defaultActive.value = '11'
        break
    }
  },
  { immediate: true }
)

function handleOpen(val) {
  if (
    val == 1 ||
    val == 2 ||
    val == 4 ||
    val == 5 ||
    val == 6 ||
    val == 8 ||
    val == 9 ||
    val == 10 ||
    val == 11
  ) {
    openSubMenuKeys.value = []
  }
}
</script>

<style scoped lang="scss">
.imgsize {
  width: 27px;
  height: 26px;
}

.user-layout {
  min-height: calc(100vh - 170px);
}

:deep(.el-menu--vertical .el-menu-item:hover) {
  background-color: transparent !important;
}

:deep(.el-menu) {
  border-right: 0;
}
</style>
